import { api, unwrap } from '@saas-kit/lib';

export interface AdminTenant {
  id: string;
  name: string;
  slug: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface AdminPage {
  total: number;
  offset: number;
  limit: number;
}

export interface AdminTenantList {
  items: AdminTenant[];
  page: AdminPage;
}

export interface ListTenantsParams {
  offset?: number;
  limit?: number;
  search?: string | null;
}

export type TenantOwnerMode = 'new' | 'invite' | 'existing';

export interface CreateTenantPayload {
  name: string;
  slug: string;
  owner_mode: TenantOwnerMode;
  owner_user_id?: string;
  owner_email?: string;
  owner_password?: string;
  owner_full_name?: string;
}

export async function listTenants(
  params: ListTenantsParams = {},
): Promise<AdminTenantList> {
  const search = params.search?.trim();
  return unwrap<AdminTenantList>(
    api.get('/admin/tenants', {
      params: {
        offset: params.offset ?? 0,
        limit: params.limit ?? 25,
        ...(search ? { search } : {}),
      },
    }),
  );
}

export async function getTenant(tenantId: string): Promise<AdminTenant> {
  return unwrap<AdminTenant>(api.get(`/admin/tenants/${tenantId}`));
}

export async function createTenant(payload: CreateTenantPayload): Promise<AdminTenant> {
  return unwrap<AdminTenant>(api.post('/admin/tenants', payload));
}

export async function suspendTenant(tenantId: string): Promise<AdminTenant> {
  return unwrap<AdminTenant>(api.post(`/admin/tenants/${tenantId}/suspend`));
}

export async function reactivateTenant(tenantId: string): Promise<AdminTenant> {
  return unwrap<AdminTenant>(api.post(`/admin/tenants/${tenantId}/reactivate`));
}

export async function archiveTenant(tenantId: string): Promise<AdminTenant> {
  return unwrap<AdminTenant>(api.delete(`/admin/tenants/${tenantId}`));
}

export interface TenantOwnerPasswordReset {
  user_id: string;
  email: string;
  full_name: string | null;
  password: string;
}

export async function resetTenantOwnerPassword(
  tenantId: string,
): Promise<TenantOwnerPasswordReset> {
  return unwrap<TenantOwnerPasswordReset>(
    api.post(`/admin/tenants/${tenantId}/reset-owner-password`),
  );
}
